import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  return (
    <div className="site-wrapper">
      <Header />
      {/* Bu div, footer'ı aşağı itecek olan esnek ana içerik alanımız olacak */}
      <div className="site-content">
        <main>
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
